import store from "../store";
import { can } from "../plugins/permissions";

export default async (to, from, next) => {
  //settings
  document.title = process.env.VUE_APP_DOCUMENT_TITLE;

  if (to.name !== from.name) window.scrollTo(0, 0);
  // handle auth state
  const requiresAuth = to.meta.requiresAuth || false;
  const preventAuth = to.meta.preventAuth || false;
  const authenticated = store.getters.authenticated;
  const authorized = to.meta.requiresPermission
    ? can(to.meta.requiresPermission)
    : true;
  if (requiresAuth && !authenticated) return next("/auth");

  if (
    authenticated &&
    store.getters.audienceRole !== "admin" &&
    store.getters.attendanceRole !== "admin" &&
    store.getters.attendanceRole !== "moderator" &&
    !store.getters.linkedAccess &&
    to.name !== "UserNotLinked"
  ) {
    return next("/user-not-linked");
  }

  if ((preventAuth && authenticated) || !authorized) return next("/");

  next();
};
